export const enum ShareholderDepositRequiredEnum {
  None = 0,
  UpTo25Percent = 1,
  TwentyFiveTo50Percent = 2,
  FiftyPercentPlus = 3,
}
